module.exports = __webpack_public_path__ + "static/media/zip.55034c73.svg";